import { createSelector } from 'reselect'
import { AppState } from 'store/store'

/**
 *
 * @param state - the application state
 * @returns
 */
export const selectBusinessAutoAcceptCertificatesReducer = (state: AppState) =>
  state.businessAutoAcceptCertificates

/**
 * Gets the BusinessAutoAcceptCertificates array from the BusinessAutoAcceptCertificates reducer
 */
export const selectSelectedShiftAutoAcceptCertificates = createSelector(
  selectBusinessAutoAcceptCertificatesReducer,
  (BusinessAutoAcceptCertificatesState) => BusinessAutoAcceptCertificatesState.data
)

/**
 * Gets the BusinessAutoAcceptCertificates' isFetching from the BusinessAutoAcceptCertificates reducer
 */
export const selectBusinessAutoAcceptCertificatesIsFetching = createSelector(
  selectBusinessAutoAcceptCertificatesReducer,
  (BusinessAutoAcceptCertificatesState) => BusinessAutoAcceptCertificatesState.isFetching
)

/**
 * Gets the BusinessAutoAcceptCertificates' meta from the BusinessAutoAcceptCertificates reducer
 */
export const selectBusinessAutoAcceptCertificatesMeta = createSelector(
  selectBusinessAutoAcceptCertificatesReducer,
  (BusinessAutoAcceptCertificatesState) => BusinessAutoAcceptCertificatesState.meta
)
